import { isS3FileId } from "./document-source";

type S3FileInfoLike = {
  fileId?: string | null;
  id?: string | null;
  fileName?: string | null;
};

export function resolveS3FileInfo(
  file?: S3FileInfoLike | null,
): { fileId: string; fileName: string } | null {
  if (!file) {
    return null;
  }

  const fileId = file.fileId || file.id;

  if (!fileId || !isS3FileId(fileId)) {
    return null;
  }

  return {
    fileId,
    fileName: file.fileName || "document.pdf",
  };
}
